import { createReducer } from '@reduxjs/toolkit'

import { arrayToObject } from 'helpers/Functions'
import { ApiKey } from 'types/GlobalApiKey'

import * as actions from '../../actions/ApiKeys/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type ApiKeyBody = {
  [key: string]: ApiKey
}

export interface ApiKeyReducerType {
  data: ApiKeyBody
  fetched: boolean
  fetching: boolean
}

const INITIAL_STATE: ApiKeyReducerType = {
  data: {},
  fetched: false,
  fetching: false
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetching = true
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = arrayToObject(action.payload.data) as ApiKeyBody
      state.fetched = true
      state.fetching = false
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetching = false
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.destroySuccess, (state, action) => {
      delete state.data[action.payload]
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
